var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.options)?_c('div',{staticClass:"chart-wrap"},[_c('highcharts',{attrs:{"options":_vm.options}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }